import { LabelKeyObject } from 'react-csv/lib/core'
import { CsvData } from 'src/Libs/dynamic-power-prices/types'

/**
 * Function to export data as csv file.
 *
 * @param filename
 * @param csvData
 * @param csvHeaders
 * @returns
 */
export const exportAsCsv = (filename: string, csvData?: Partial<CsvData>[], csvHeaders?: LabelKeyObject[]): void => {
  try {
    if (!csvData || csvData.length === 0 || !csvHeaders) return

    const headerRow = csvHeaders.map(h => `"${sanitizeHeaderName(h.label)}"`).join(';')
    const rows = csvData.map(row => csvHeaders.map(h => sanitizeHeaderName(String((row as Record<string, unknown>)[h.key] ?? ''))).join(';'))
    const csv = [headerRow, ...rows].join('\n')
    const sanitizedFilename = sanitizeFilename(filename.endsWith('.csv') ? filename : `${filename}.csv`)

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    console.log({ filename })
    link.setAttribute('download', sanitizedFilename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (err) {
    console.error('CSV export failed', err)
  }
}

const sanitizeHeaderName = (str: string): string => {
  const invisibleUnicodeCharacters = /[\u200B-\u200F\u202A-\u202E\u2060-\u206F\u00AD\uFEFF]/g

  return str.replace(invisibleUnicodeCharacters, '')
}

const sanitizeFilename = (filename: string): string => {
  const invisibleUnicodeCharacters = /[\u200B-\u200F\u202A-\u202E\u2060-\u206F\u00AD\uFEFF]/g
  const multipleUnderscoresOrSpaces = /[_\s]{2,}/g

  return filename.replace(invisibleUnicodeCharacters, '').replace(multipleUnderscoresOrSpaces, '_')
}
